import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import type { ProjectLLMContext } from "@domain/project/ProjectContext";

export type CitationType =
  | "budget"
  | "phase"
  | "contractor"
  | "floorplan"
  | "designItem"
  | "permit"
  | "general";

export interface Citation {
  type: CitationType;
  itemId?: number | string;
  label: string;
}

export interface AIObservation {
  severity: "info" | "warn" | "risk";
  category: "budget" | "timeline" | "scope" | "code" | "vendor" | "risk";
  title: string;
  body: string;
  citations: Citation[];
}

export interface AIReview {
  id: string;
  flowName: string;
  promptVersion: string;
  modelUsed: string;
  contextHash: string;
  observations: AIObservation[];
  summary: string;
  tokensIn: number;
  tokensOut: number;
  costUsd: number;
  createdAt: number;
  createdBy: string;
  cached?: boolean;
}

export interface ProjectReviewerCallInput {
  ownerUid: string;
  projectId: string;
  contextHash: string;
  forceRefresh?: boolean;
  context: ProjectLLMContext;
  /** Titles user has rejected; LLM will be told to avoid them. */
  rejectedTitles?: string[];
}

export async function callProjectReviewer(
  input: ProjectReviewerCallInput
): Promise<AIReview> {
  const call = httpsCallable<ProjectReviewerCallInput, AIReview>(
    functions,
    "projectReviewer"
  );
  const result = await call(input);
  return result.data;
}
